import Http from "enslaver-http";
import token from "./token";
import config from '../config/app';

const apiMap = {
  localhost: config.finalCoursewareApiService,
  "final-courseware-vue.caihonggou.com": "https://final-courseware-api.caihonggou.com",
  "final-courseware.aikaola.com": "https://final-courseware-api.aikaola.com",
};


const errorAOP = (res) => {
  if (res.status === 401) window.location.href = "/login";

  throw res;
};

let isLoc = false;
if (window.location.hostname.startsWith('192') || window.location.hostname.startsWith('loc')) {
  isLoc = true;
}

export const baseURI = isLoc ? apiMap.localhost : apiMap[window.location.hostname];

export default new Http({
  baseURI,
  baseHeaders: {
    Authorization: `Bearer ${token.get()}`,
  },
  errorAOP,
});

